import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  
  constructor(private router: Router, private authService: AuthService) { }

  canActivate(): boolean {
    if (!this.authService.getToken()) {
      this.router.navigateByUrl('/intro');
    }
    return this.authService.getToken();
  }

}